// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.Card_card__DtjLn {
  margin: 0.5rem;
  background-color: white;
  min-width: 20rem;
  box-shadow: 0px 2px 4px rgba(130, 130, 130, 0.2509803922);
}
@media only screen and (max-width: 1024px) {
  .Card_card__DtjLn {
    min-width: calc(100% - 1rem);
  }
}
.Card_card__DtjLn {
  border: 1px solid #E8E8E8;
}

.Card_card-wide__LqJKU {
  min-width: calc(100% - 1rem);
}

.Card_card-container__NB1rR {
  display: flex;
  flex-wrap: wrap;
  padding: 0.5rem;
  align-items: flex-start;
  width: 100%;
}

.Card_row__SteGj {
  min-height: 4rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #efefef;
}

.Card_row__SteGj:last-child {
  border-bottom: none;
}

.Card_text__CZlVc {
  margin-left: 1rem;
  flex: 1 1;
  color: #666;
}

.Card_icon__sd0Cl {
  margin-left: 1rem;
}

.Card_button__4Xaq0 {
  width: 4rem;
  height: 4rem;
  max-width: 4rem;
  max-height: 4rem;
  background-color: rgba(0, 0, 0, 0);
}

.Card_button__4Xaq0:hover, .Card_clickable__ZA\\+uw:hover {
  background-color: #efefef;
  transition: 0.3s;
}

.Card_email-wrapper__SGryi {
  display: flex;
  width: 100%;
}

.Card_input-list__7FSDB {
  flex: 1 1;
  position: relative;
  width: 100%;
}

.Card_input__xvf4f {
  position: relative;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  padding: 0.5rem;
  width: calc(100% - 1rem);
}

.Card_input__xvf4f:focus {
  outline: none;
}

.Card_input-label__Ftzn8 {
  position: absolute;
  top: 1px;
  left: 1rem;
  height: 0.5em;
  font-size: 10px;
}

.Card_input__xvf4f.Card_show__SB\\+cO {
  border: 1.5px solid red;
  padding-top: 10px;
}

.Card_error__0m3M7 {
  color: rgb(255, 0, 0);
}

.Card_error__0m3M7.Card_hide__81J2d {
  display: None;
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/components/Alarms/components/Card/Card.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AChCA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EAEA,yDAAA;AAMF;AAJE;EAPF;IAQI,4BAAA;EAOF;AACF;AAhBA;EAUE,yBAAA;AASF;;AANA;EACE,4BAAA;AASF;;AANA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;AASF;;AANA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AASF;;AANA;EACE,mBAAA;AASF;;AANA;EACE,iBAAA;EACA,SAAA;EACA,WAAA;AASF;;AANA;EACE,iBAAA;AASF;;AANA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AASF;;AANA;EACE,yBAAA;EACA,gBAAA;AASF;;AANA;EACE,aAAA;EACA,WAAA;AASF;;AANA;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AASF;;AANA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AASF;;AANA;EACE,aAAA;AASF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AASF;;AANA;EACE,uBAAA;EACA,iBAAA;AASF;;AANA;EACE,qBAAA;AASF;;AANA;EACE,aAAA;AASF","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.card {\n  margin: 0.5rem;\n  background-color: white;\n  min-width: 20rem;\n  box-shadow: 0px 2px 4px rgba(130, 130, 130, 0.2509803922);\n}\n@media only screen and (max-width: 1024px) {\n  .card {\n    min-width: calc(100% - 1rem);\n  }\n}\n.card {\n  border: 1px solid #E8E8E8;\n}\n\n.card-wide {\n  min-width: calc(100% - 1rem);\n}\n\n.card-container {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.5rem;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.row {\n  min-height: 4rem;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #efefef;\n}\n\n.row:last-child {\n  border-bottom: none;\n}\n\n.text {\n  margin-left: 1rem;\n  flex: 1;\n  color: #666;\n}\n\n.icon {\n  margin-left: 1rem;\n}\n\n.button {\n  width: 4rem;\n  height: 4rem;\n  max-width: 4rem;\n  max-height: 4rem;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.button:hover, .clickable:hover {\n  background-color: #efefef;\n  transition: 0.3s;\n}\n\n.email-wrapper {\n  display: flex;\n  width: 100%;\n}\n\n.input-list {\n  flex: 1;\n  position: relative;\n  width: 100%;\n}\n\n.input {\n  position: relative;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  padding: 0.5rem;\n  width: calc(100% - 1rem);\n}\n\n.input:focus {\n  outline: none;\n}\n\n.input-label {\n  position: absolute;\n  top: 1px;\n  left: 1rem;\n  height: 0.5em;\n  font-size: 10px;\n}\n\n.input.show {\n  border: 1.5px solid red;\n  padding-top: 10px;\n}\n\n.error {\n  color: rgb(255, 0, 0);\n}\n\n.error.hide {\n  display: None;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Card_card__DtjLn`,
	"card-wide": `Card_card-wide__LqJKU`,
	"card-container": `Card_card-container__NB1rR`,
	"row": `Card_row__SteGj`,
	"text": `Card_text__CZlVc`,
	"icon": `Card_icon__sd0Cl`,
	"button": `Card_button__4Xaq0`,
	"clickable": `Card_clickable__ZA+uw`,
	"email-wrapper": `Card_email-wrapper__SGryi`,
	"input-list": `Card_input-list__7FSDB`,
	"input": `Card_input__xvf4f`,
	"input-label": `Card_input-label__Ftzn8`,
	"show": `Card_show__SB+cO`,
	"error": `Card_error__0m3M7`,
	"hide": `Card_hide__81J2d`
};
export default ___CSS_LOADER_EXPORT___;
